import PropTypes from 'prop-types';
import { getPrice } from '../../../../../common/routines/utils';
import { ADDENDUM_IN_PROGRESS } from '../../../../../constants/reports';
import { formatDate } from '../../../../../utils/formatters';

const ARAgingDetailedReportRow = ({ rowData, id, nestedColumnsNumber, slNo }) => {
  const { purchaserName, onePortalId, service } = rowData;

  return (
    <tr key={id} className="table-body-tr">
      <td width="50px" align="center" className="valign-middle">
        {slNo}
      </td>
      <td className="valign-middle">
        <div className="mb-1 display-block">{purchaserName}</div>
        <div className="unit-no">{onePortalId}</div>
      </td>
      {[...Array(nestedColumnsNumber)].map((_col, column) => {
        return (
          <td key={column} className="p-0 tb-next td-next-1">
            {service?.map((serviceType, stIndex) => {
              return (
                <table key={stIndex} className="inner-table">
                  <tbody>
                    {serviceType.serviceDetails.map((rowDataValues, subIndex) => {
                      return (
                        <>
                          {column === 0 && (
                            <tr>
                              <td className="detail-td">
                                {subIndex === 0 && (
                                  <div className="mb-1 display-block detail-div">
                                    {`${serviceType?.serviceType} (${serviceType?.toatlNoService})`}
                                  </div>
                                )}
                                <span className="unit-no">{rowDataValues?.serviceNumber}</span>
                                {rowDataValues?.addendumStatus === ADDENDUM_IN_PROGRESS && (
                                  <span className="addendum-note">Note: Addendum In Progress</span>
                                )}
                              </td>
                            </tr>
                          )}
                          {column === 1 && (
                            <tr className="tr-next">
                              <td>{formatDate(rowDataValues?.contractDate)}</td>
                            </tr>
                          )}
                          {column === 2 && (
                            <tr className="tr-next">
                              <td>{rowDataValues?.pastDueDays || '-'}</td>
                            </tr>
                          )}
                          {column === 3 && (
                            <tr className="tr-next">
                              <td>{getPrice(rowDataValues?.totalAmount)}</td>
                            </tr>
                          )}
                          {column === 4 && (
                            <tr className="tr-next">
                              <td>{getPrice(rowDataValues?.unDue)}</td>
                            </tr>
                          )}

                          {column === 5 && (
                            <tr className="tr-next">
                              <td>{getPrice(rowDataValues?.overDue)}</td>
                            </tr>
                          )}
                          {column === 6 && (
                            <tr className="tr-next">
                              <td>{getPrice(rowDataValues?.day30)}</td>
                            </tr>
                          )}
                          {column === 7 && (
                            <tr className="tr-next">
                              <td>{getPrice(rowDataValues?.day60)}</td>
                            </tr>
                          )}
                          {column === 8 && (
                            <tr className="tr-next">
                              <td>{getPrice(rowDataValues?.day90)}</td>
                            </tr>
                          )}
                          {column === 9 && (
                            <tr className="tr-next">
                              <td>{getPrice(rowDataValues?.day120)}</td>
                            </tr>
                          )}
                          {column === 10 && (
                            <tr className="tr-next">
                              <td>{getPrice(rowDataValues?.above120)}</td>
                            </tr>
                          )}
                          {column === 11 && (
                            <tr className="tr-next">
                              <td className="ar-text-wrap">{rowDataValues?.type || '-'}</td>
                            </tr>
                          )}
                          {column === 12 && (
                            <tr className="tr-next">
                              <td className="ar-text-wrap">{rowDataValues?.subType || '-'}</td>
                            </tr>
                          )}
                          {column === 13 && (
                            <tr className="tr-next">
                              <td>
                                {rowDataValues?.anticipatedValue > 0
                                  ? getPrice(rowDataValues?.anticipatedValue)
                                  : '-'}
                              </td>
                            </tr>
                          )}
                        </>
                      );
                    })}
                  </tbody>
                </table>
              );
            })}
          </td>
        );
      })}
    </tr>
  );
};

ARAgingDetailedReportRow.propTypes = {
  rowData: PropTypes.shape({
    purchaserName: PropTypes.string,
    onePortalId: PropTypes.string,
    service: PropTypes.shape([
      {
        serviceType: PropTypes.string,
        toatlNoService: PropTypes.number,
        serviceDetails: PropTypes.shape([
          {
            serviceNumber: PropTypes.string,
            contractDate: PropTypes.string,
            pastDueDays: PropTypes.string,
            totalAmount: PropTypes.number,
            unDue: PropTypes.number,
            overDue: PropTypes.number,
            day30: PropTypes.number,
            day60: PropTypes.number,
            day90: PropTypes.number,
            day120: PropTypes.number,
            above120: PropTypes.number,
          },
        ]),
      },
    ]),
  }).isRequired,
  id: PropTypes.number.isRequired,
  nestedColumnsNumber: PropTypes.number.isRequired,
  slNo: PropTypes.number.isRequired,
};

export default ARAgingDetailedReportRow;
